import * as i18n from "../../../i18n";
import {Dimensions, PixelRatio, Platform} from "react-native";
import moment from "moment";
import {Store} from "../../reducers/store";
import moment_tz from "moment-timezone";

export function formatSharpHour(value) {
    return ((parseInt(value) < 10 ? "0" : "") + value + ':00')
}


export const formatTimeFromMoment = (moment, format = null) => {
    if (!format) {
        format = Store.getState().data.config.time_format
    }

    return moment.format(format === "ampm" ? 'h:mm A' : 'HH:mm')
}

export const getDaySchedule = (date = null) => {
    const locationSchedule = Store.getState().data.config.schedule
    const timezone = Store.getState().data.config.timezone

    const currentDay = date ?
        moment_tz.tz(date, timezone).utc().tz(timezone).day() :
        moment_tz.tz(timezone).day()

    return locationSchedule[currentDay + 1]
}

export const getMilitaryTime = (time) => {
    return moment(time).format('HH:mm')
}

export const getClosestMultipleOfGranularity = (granularity) => {
    if (!granularity) {
        granularity = 5
    }

    let now = moment_tz.tz(Store.getState().data.config.timezone)

    const minutesToSubtract = now.minute() % granularity

    return now.add(granularity - minutesToSubtract, "minutes").format('HH:mm')
}

export const range = (start, end) => {
    return Array(end - start).fill().map((_, idx) => start + idx)
}
